import types from '../../types';

const initialState = {
  loading: false,
  data: null,
  gasPrice: null,
};

const gasFeeSettings = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.GET_GAS_FEE_SETTINGS_START:
      return { ...state, loading: true };

    case types.GET_GAS_FEE_SETTINGS_SUCCESS:
      return { ...state, data: payload, loading: false };

    case types.GET_CURRENT_GAS_PRICE_SUCCESS:
      return { ...state, gasPrice: payload, loading: false };

    case types.GET_GAS_FEE_SETTINGS_FAILURE:
      return { ...state, loading: false };

    default:
      return state;
  }
};

export default gasFeeSettings;
